import React, { ReactNode } from 'react';
import CardFooter from 'components/CardFooter/CardFooter';

interface CardWithAsideProps {
  title?: string;
  aside?: ReactNode;
  footer?: ReactNode;
}

export const CardWithAside: React.FC<CardWithAsideProps> = ({
  children,
  title,
  aside,
  footer,
}) => {
  return (
    <div className="card">
      <div className="cardBody">
        <aside>
          {title && (
            <h2 className="mb-4 text-lg font-semibold text-gray-800">
              {title}
            </h2>
          )}
          {aside || null}
        </aside>
        <main>{children}</main>
      </div>
      {footer && <CardFooter>{footer}</CardFooter>}
    </div>
  );
};

export default CardWithAside;
